module.exports = __webpack_public_path__ + "assets/get-screenshot.ddcf258e.svg";